document.addEventListener("click",(e)=>{
  const bssCheckout = document.querySelector(".btn.btn-checkout");
  const bin = e.target.closest('.custom-shop-pay-button');
  if (typeof BSS_B2B !== "undefined" && bssCheckout && (e.target.name === "checkout" || (bin && bin.name === 'checkout') )) {
    e.preventDefault();
    e.stopImmediatePropagation();
    bssCheckout.click();
  }
},true)

function updateCartNote(noteText) {
  const noteInput = document.querySelector('#cart-note');

  if (noteInput) {
    noteInput.value = noteText;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ note: noteText })
    })
    .then(res => {
      if (!res.ok) throw new Error('Failed to update cart note');
      return res.json();
    })
    .then(data => {
      console.log('Cart note updated:', data.note);
    })
    .catch(error => {
      console.error('Error updating cart note:', error);
    });
  }
}

function debounce(fn, delay) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), delay);
  };
}

document.addEventListener("DOMContentLoaded", e => {
  const noteInput = document.querySelector('#cart-note');
  if (noteInput) {
    const debouncedUpdate = debounce(() => {
      updateCartNote(noteInput.value);
    }, 300);
  
    noteInput.addEventListener('input', debouncedUpdate);
  }
})

